module.exports = __webpack_public_path__ + "static/crash_test-9c73f3894c7f50551fb18d55031332d7.png";